import { useState, useEffect } from "react";

/**
 * Turn a Blob/File into an object URL and revoke it when the blob changes
 * or the component unmounts.
 * @param {Blob|null} blob
 * @returns {string|null}
 */
const useObjectUrl = (blob) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return url;
};

export default useObjectUrl;
